<template lang="pug">
#app
  el-container
    el-aside(width="200px" class="aside")
      .logo
        h1 露營地搜尋
      el-menu(
        :default-active="activeIndex"
        class="nav-menu"
        mode="vertical"
        router
        @select="handleSelect"
      )
        el-menu-item(index="/")
          i.el-icon-search
          span 營地搜尋
        el-menu-item(index="/intro")
          i.el-icon-info
          span 網站介紹
        el-menu-item(index="/camp/list")
          i.el-icon-menu
          span 瀏覽所有營地
    el-container
      el-main
        router-view
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      activeIndex: '/'
    }
  },
  methods: {
    handleSelect(key) {
      this.activeIndex = key
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.activeIndex = to.path
      }
    }
  },
}
</script>

<style>
html, body, div {
  margin: 0;
  padding: 0;
}
body {
  background-color: #f0f2f5;
}
#app {
  font-family: 'Microsoft JhengHei', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
  background-color: #f0f2f5;
}

.aside {
  background-color: #304156;
  color: #fff;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  transition: width 0.3s;
}

.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: #2b2f3a;
  color: #fff;
}

.logo h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.nav-menu {
  border-right: none;
  background-color: #304156;
}

.nav-menu .el-menu-item {
  color: #bfcbd9;
  background-color: #304156 !important;
}

.nav-menu .el-menu-item:hover {
  background-color: #263445 !important;
}

.nav-menu .el-menu-item.is-active {
  color: #409EFF !important;
  background-color: #263445 !important;
}

.el-main {
  margin-left: 200px;
  padding: 20px;
  min-height: 100vh;
}

@media screen and (max-width: 768px) {
  .aside {
    width: 64px !important;
  }
  
  .logo h1 {
    display: none;
  }
  
  .el-main {
    margin-left: 64px;
  }
}
</style>
